/**
 * Emit hosts for the `memory` analytics group — 3 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { UploadSource } from '@/models/analytics/features/memory';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';

export function replacementsUploadedV2({
  count,
  source,
}: {
  count: number;
  source: UploadSource;
}) {
  // Call old analytics
  trackBulkUploadReplacements({
    count,
    from: source === UploadSource.EDITOR ? 'editor' : 'settings',
  });

  // Track with new V2 framework
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ReplacementsUploaded,
    props: {
      count,
      source,
    },
  });
}

/**
 * Track snippets bulk upload event
 * @param count - Number of snippets uploaded
 * @param source - Source of the upload (editor or settings)
 */
export function snippetsUploadedV2({
  count,
  source,
}: {
  count: number;
  source: UploadSource;
}) {
  // Track with new V2 framework
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.SnippetsUploaded,
    props: {
      count,
      source,
    },
  });
}

export function trackBulkUploadReplacements(input: {
  count: number;
  from: 'editor' | 'settings';
}) {
  trackLegacyEvent({
    name: SegmentObjectName.General,
    props: {
      action: SegmentActionName.BulkUploadReplacements,
      count: input.count,
      from: input.from,
    },
  });

  // V2 — Amplitude migration
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.SnippetUploaded,
    props: {
      count: input.count,
      source: input.from,
    },
  });
}
